var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _g3, _path8, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanternaLigada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1505_2047)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 22.5,
    r: 21.5,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1505_2047",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 34,
    width: 7,
    height: 5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8721 34.3878H26.4901V38.0086H20.8721V34.3878Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1505_2047)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4901 34.4118V35.2148C26.4931 35.9658 26.2061 36.6688 25.6771 37.1988C25.1501 37.7248 24.4441 38.0158 23.6961 38.0088C22.1461 38.0088 20.8791 36.7418 20.8751 35.1868L20.8721 34.3878L26.4901 34.4118Z",
    fill: "#979797"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6966 26.2423C24.6966 26.8033 24.2156 27.2843 23.6546 27.2843C23.0766 27.2803 22.6056 26.8103 22.6026 26.2323C22.5986 25.9513 22.7096 25.6883 22.9036 25.4943C23.1006 25.2973 23.3636 25.1863 23.6446 25.1903C24.2226 25.1933 24.6936 25.6643 24.6966 26.2423Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4304 26.2423C25.4334 26.7163 25.2474 27.1663 24.9114 27.5023C24.5784 27.8343 24.1284 28.0213 23.6544 28.0183C22.6754 28.0143 21.8714 27.2113 21.8684 26.2323C21.8644 25.2803 22.6924 24.4523 23.6444 24.4563C24.6234 24.4593 25.4274 25.2623 25.4304 26.2423ZM24.9044 20.7033L20.8714 20.6863L20.8674 20.6893L20.8164 20.6863L20.8644 33.6533L26.4864 33.6743L26.4374 20.7073L24.9044 20.7033Z",
    fill: "#979797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7671 15.9473L28.4311 18.2073C28.2821 19.2363 27.4201 19.9803 26.3821 19.9733L20.8741 19.9563C19.8501 19.9493 18.9571 19.1803 18.8011 18.1663L18.4551 15.9093L28.7671 15.9473Z",
    fill: "#979797"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9574 13.3476C29.0574 13.4686 29.1064 13.6276 29.0824 13.7836L28.8704 15.2136L18.3404 15.1716L18.1224 13.7356C18.0944 13.5756 18.1394 13.4276 18.2434 13.3026L18.2714 13.2746C18.3714 13.1746 18.5034 13.1186 18.6484 13.1186L28.5454 13.1576C28.7014 13.1606 28.8504 13.2266 28.9574 13.3476Z",
    fill: "#979797"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0762 10.591C24.1652 10.502 24.2202 10.379 24.2192 10.243L24.2052 6.487C24.2042 6.217 23.9842 5.999 23.7142 6C23.4442 6 23.2252 6.22 23.2262 6.491L23.2402 10.247C23.2412 10.517 23.4612 10.735 23.7322 10.734C23.8662 10.734 23.9882 10.679 24.0762 10.591Z",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1505_2047",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 6,
    width: 4,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4062 6.89565H29.4376V11.004H26.4062V6.89565Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1505_2047)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2171 6.9752C28.9901 6.8272 28.6871 6.8922 28.5391 7.1162L26.4871 10.2462C26.3381 10.4722 26.4011 10.7762 26.6271 10.9242C26.8251 11.0532 27.0811 11.0212 27.2421 10.8612C27.2651 10.8382 27.2861 10.8122 27.3051 10.7832L29.3581 7.6532C29.5061 7.4272 29.4431 7.1232 29.2171 6.9752Z",
    fill: "#979797"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1505_2047",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 6,
    width: 4,
    height: 5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6.85579H21.0554V10.98H18V6.85579Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1505_2047)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8356 10.8989C20.8636 10.8799 20.8896 10.8589 20.9126 10.8359C21.0736 10.6759 21.1046 10.4179 20.9746 10.2209L18.8976 7.0759C18.7496 6.8499 18.4456 6.7879 18.2196 6.9369C17.9946 7.0859 17.9316 7.3899 18.0816 7.6149L20.1576 10.7599C20.3066 10.9859 20.6106 11.0479 20.8356 10.8989Z",
    fill: "#979797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1505_2047",
    x: 0,
    y: 0,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1505_2047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1505_2047",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanternaLigada);
export default __webpack_public_path__ + "static/media/lanterna_ligada.cd073083fa86a6bfd5e349ad48cae306.svg";
export { ForwardRef as ReactComponent };